import CategoriesImage from '../assets/images/Banners/categories-banner.png';
import TreatmentsImage from '../assets/images/Banners/treatments-banner.png';
import TreatmentImage from '../assets/images/Banners/categories-banner.png';
import PackagesImage from '../assets/images/Banners/packages-banner.png';
import GalleryImage from '../assets/images/Banners/gallery-banner.png';
import ContactUsImage from '../assets/images/Banners/contact-us.jpg';
import AboutUsImage from '../assets/images/Banners/aboutus-banner-1.jpg';

const BannerData = [ 
    {
        id: 1,
        title: "Categories",
        description:
            "Discover a world of wellness tailored for you, with carefully curated options designed to rejuvenate your body and mind.",
        alt: "Categories Banner Image",
        image: CategoriesImage,
    },
    {
        id: 2,
        title: "Treatments",
        description:
            "Experience time-honored therapies blended with modern care, crafted to restore balance, vitality, and inner peace.",
        alt: "Treatments Banner Image",
        image: TreatmentsImage,
    },
    {
        id: 3,
        title: "Packages",
        description:
            "Indulge in thoughtfully designed packages that bring together the best of our services for complete wellness and relaxation.",
        alt: "Packages Banner Image",
        image: PackagesImage,
    },
    {
        id: 4,
        title: "Gallery",
        description:
            "Step into our serene space through captivating visuals that reflect the essence of healing and tranquility.",
        alt: "Gallery Banner Image",
        image: GalleryImage,
    },
    {
        id: 5,
        title: "Contact Us",
        description:
            "Your journey to Ayurvedic healing is just a call away. Book online, via email, or by phone. For any questions or guidance, feel free to reach out!",
        alt: "Contact us Banner Image",
        image: ContactUsImage,
    },
    {
        id: 6,
        title: "About Us",
        description:
            "Learn about our story, philosophy, and commitment to offering authentic Ayurvedic healing with a personal touch.",
        alt: "About us Banner Image",
        image: AboutUsImage,
    },
    {
        id: 7,
        title: "Treatment",
        description:
            "Find personalized treatments that nurture your well-being, combining ancient traditions with modern expertise.",
        alt: "Treatment Banner Image",
        image: TreatmentImage,
    },
    {
        id: 8,
        title: "Loyalty Cards",
        description:
            "Enjoy exclusive benefits and rewards every time you choose us—because your loyalty deserves recognition.",
        alt: "Loyalty cards Banner Image",
        image: TreatmentImage,
    },
    {
        id: 9,
        title: "Loyalty Card",
        description:
            "Celebrate your wellness journey with rewards and special privileges designed just for you.",
        alt: "Loyalty cards Banner Image",
        image: TreatmentImage,
    },
];

export default BannerData;